export default "__VITE_ASSET__ad1t9B8O__"